<template>
  <div class="bg-white p-2 border">
    <UserProfileFilter :filters="filters" :application="application">
      <template #default>
        <h2 class="h5">
          {{ i18n('Users') }}
          <span class="small text-muted">({{ userProfiles.length }})</span>
        </h2>
      </template>
      <template #buttons>
        <UserProfileCreateAction @created="reload" v-if="can('USER_MANAGE') || can('RESPONSIBLE_USER_MANAGE')" btnClass="ms-1 btn btn-sm btn-outline-dark"
          :application="application" />
      </template>
    </UserProfileFilter>

    <UserProfileList :application="application" :userProfiles="userProfiles" :loading="loading" @deleted="reload"
      @updating="loading = true" @updated="reload" :withUser="true" :withApplication="false" />
  </div>
</template>

<script>
import api from "@/api.js";
import {
  duplicate,
  flattenUrlObject,
} from "@/tools/object.js";
import UserProfileCreateAction from "@/components/userProfile/UserProfileCreateAction.vue";
import UserProfileFilter from "@/components/userProfile/UserProfileFilter.vue";
import UserProfileList from "@/components/userProfile/UserProfileList.vue";

export default {
  components: {
    UserProfileCreateAction,
    UserProfileFilter,
    UserProfileList,
  },
  props: {
    application: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      userProfiles: [],
      filters: {},
      loading: false,

    }
  },
  mounted() {
    api.auth().then((user) => {
      this.$root.loggedUser = user;

      if (!this.can('USER_MANAGE')
        && !this.can('USER_ACCESS')) {
        this.$router.push({
          name: 'Index',
        });
        return;
      }

      this.load();
    });
  },
  watch: {
    params: {
      handler() {
        this.reload();
      },
      deep: true,
    },
  },
  computed: {
    params() {
      let params = duplicate(this.filters);
      params.acl = 'profile';

      flattenUrlObject(params);

      return params;
    },
  },
  methods: {
    load(force) {
      clearTimeout(this.loadTimeout);
      this.loading = true;

      if (!force) {
        this.loadTimeout = setTimeout(() => {
          this.load(true);
        }, 250);
        return;
      }

      api.get(`applications/${this.application.id}/users/profiles`, this.params).then(userProfiles => {
        this.userProfiles = userProfiles;
        this.loading = false;
      });
    },
    reload() {
      this.load();
    },
  },
};
</script>